import * as Yup from "yup";

export default () => {
  return Yup.object().shape({
    csvUrl: Yup.string()
      .required("common:validator.required")
      .max(200, "common:validator.max50Chars"),
  });
};
